import { memo, useCallback } from 'react'
import isEqual from 'react-fast-compare'
import { useClearRefinements, useCurrentRefinements } from 'react-instantsearch'
import { AtChip, AtChipVariant, FocusElement, focusElementClasses } from '@curran-catalog/curran-atomic-library'

import { environment } from '@config/environment'
import { flooringRefinements, furnitureRefinements } from '@services/algolia'
import { SiteDomain } from 'types'

const ClearAllRefinements = memo(() => {
  const { refine, canRefine } = useClearRefinements()

  const handleClearAllRefinements = useCallback(() => refine(), [refine])

  return (
    <button
      type="button"
      className={`underline text-secondary text-sm leading-4 disabled:opacity-75 ${
        focusElementClasses[FocusElement.FOCUS_VISIBLE]
      }`}
      onClick={handleClearAllRefinements}
      disabled={!canRefine}
    >
      Clear All
    </button>
  )
}, isEqual)

export type CurrentRefinement = {
  category?: string
  label: string
  value: string | number
}

const CurrentRefinementsComponent = () => {
  const { items, refine } = useCurrentRefinements()

  return (
    <div>
      <div hidden={items.length === 0}>
        <ClearAllRefinements />
      </div>

      <ul className="my-1 py-1 flex flex-row md:flex-col gap-2 md:flex-nowrap overflow-scroll md:overflow-hidden">
        {items.map((item) =>
          item.refinements.map((refinement) => {
            const foundRefinement = (
              environment.siteDomain === SiteDomain.FURNITURE ? furnitureRefinements : flooringRefinements
            ).find(({ options }) => options?.attribute === refinement.attribute)
            const labelChip = `${foundRefinement?.header ?? refinement.attribute}: ${refinement.label.split('|')[0]}`

            return (
              <AtChip
                key={[foundRefinement?.header ?? refinement.attribute, refinement.label].join(':')}
                label={labelChip}
                onClick={() => refine(refinement)}
                variant={AtChipVariant.OUTLINED}
              />
            )
          }),
        )}
      </ul>
    </div>
  )
}

export const CurrentRefinements = memo(CurrentRefinementsComponent, isEqual)
